import React from 'react';

/**
 * Portal home for someone who has booked a Goal-Setting Meeting but is not a
 * plan client yet. Deliberately asks for nothing.
 */
export default function MeetingStageHome({ name, onLogout }) {
  return (
    <div className="app">
      <div className="login-container">
        <h1>Financial Progress Portal</h1>
        <h2 style={{ marginTop: 0, color: '#2D5074' }}>Welcome{name ? `, ${name}` : ''}.</h2>
        <p>
          Your account is set up. There is nothing to connect or fill in before your Goal-Setting
          Meeting. A short list of the decisions on your mind is all you need to bring.
        </p>
        <p>
          If we go on to build a comprehensive plan together, this is where you’ll connect your
          accounts and see your reports. I’ll let you know when it’s time.
        </p>
        <p>
          <a href="/calculators">Explore the planning calculators</a>
        </p>
        <button type="button" onClick={onLogout}>Log out</button>
      </div>
    </div>
  );
}
